// ─────────────────────────────────────────────────────────────────
// Glass-i — Employee Transfer helpers (Stage HRMS-3). Pure functions.
// ─────────────────────────────────────────────────────────────────

export const TRANSFER_TYPE_OPTIONS = [
  { value: 'BRANCH', label: 'Branch' },
  { value: 'DEPARTMENT', label: 'Department' },
  { value: 'DESIGNATION', label: 'Designation' },
  { value: 'MANAGER', label: 'Manager' },
  { value: 'MULTIPLE', label: 'Multiple' }
];

export const TRANSFER_STATUS_OPTIONS = [
  { value: 'DRAFT', label: 'Draft' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'CANCELLED', label: 'Cancelled' }
];

export function transferStatusColor(status) {
  switch (String(status || '').toUpperCase()) {
    case 'APPROVED': return 'green';
    case 'CANCELLED': return 'default';
    case 'DRAFT': return 'gold';
    default: return 'blue';
  }
}

// A DRAFT transfer can be edited / approved / cancelled; anything else
// is locked.
export function isDraft(record) {
  return !!record && String(record.status).toUpperCase() === 'DRAFT';
}

// Build the create/update payload from AntD form values. Empty targets
// are sent as null (= no change on that dimension). effectiveDate may be
// a dayjs instance (has .toISOString) or a string.
export function buildTransferPayload(values = {}) {
  const v = values || {};
  const toIso = (d) => {
    if (!d) return undefined;
    if (typeof d === 'string') return d;
    if (typeof d.toISOString === 'function') return d.toISOString();
    return undefined;
  };
  const orNull = (x) => (x === undefined || x === '' ? null : x);
  const payload = {
    toBranchId:      orNull(v.toBranchId),
    toDepartmentId:  orNull(v.toDepartmentId),
    toDesignationId: orNull(v.toDesignationId),
    toManagerId:     orNull(v.toManagerId),
    reason:          v.reason || null,
    remarks:         v.remarks || null
  };
  if (v.employeeId) payload.employeeId = v.employeeId;
  if (v.transferType) payload.transferType = v.transferType;
  const eff = toIso(v.effectiveDate);
  if (eff !== undefined) payload.effectiveDate = eff;
  return payload;
}

// Compact human summary of the dimensions a record changes.
export function describeChange(record = {}) {
  const parts = [];
  const push = (label, from, to) => {
    if ((from || null) !== (to || null)) parts.push(`${label}: ${from || '—'} → ${to || '—'}`);
  };
  push('Branch', record.fromBranchName, record.toBranchName);
  push('Department', record.fromDepartmentName, record.toDepartmentName);
  push('Designation', record.fromDesignationName, record.toDesignationName);
  push('Manager', record.fromManagerName, record.toManagerName);
  return parts.length ? parts.join(' · ') : 'No change';
}
